import { useIntl } from "react-intl";

import { CircularProgress } from "@/components/CircularProgress/CircularProgress";

type Props = {
  count: number;
};

export const OrdersInCreationCard = ({ count }: Props) => {
  const intl = useIntl();

  return (
    <div className="section-card mb-2 flex flex-row items-center gap-2 rounded-3xl">
      <CircularProgress size={20} />
      <span className="text-sm">
        {intl.formatMessage(
          {
            defaultMessage:
              "{count, plural, =1 {# order is} other {# orders are}} in the process of creation...",
            description:
              "Section heading for orders that are currently being processed",
          },
          { count },
        )}
      </span>
    </div>
  );
};
